import $ from 'jquery';
import _ from 'lodash';
import baseForm from 'common/js/forms/base';
import selectize from 'common/js/selectize';
import 'common/js/clearform';

export default function (el) {
    var form = $(el),
        base = baseForm(form);
        var wheelData = form_data_non_stock_wheel_search_by_params;  // From HTML

    if(typeof el != 'string' && 'no-selectize' in el) {
        (function() {
            var $brand = form.find('[name=brand]');
            var $model = form.find('[name=model]');

            base.clearOptions($brand);
            base.clearOptions($model);

            base.addOption($brand, '', '-');
            base.addOption($model, '', '-');

            var ids_names =  _.map(Object.keys(wheelData), function(k) {
                return [ k, wheelData[k].name];
            });

            var sorted = _.sortBy(ids_names, function(w) {
                return w[1];
            });

            for(var e of sorted) {
                base.addOption($brand, e[0], e[1]);
            }

            var brandChanged = function () {
                base.clearOptions($model);
                base.addOption($model, '', '-');

                var selectedBrand = $brand.val();
                if (selectedBrand) {
                    for(var v of wheelData[selectedBrand].models) {
                        base.addOption($model, v[0], v[1]);
                    }
                }
            };

            $brand.on('change', brandChanged);
        })();
    }
    else {
        (function() {
            form.find('[name=brand]').selectize({placeholder: 'Merkki'});
            form.find('[name=model]').selectize({placeholder: 'Malli'});
            form.find('[name=size]').selectize({placeholder: 'Koko'});
            form.find('[name=width]').selectize({placeholder: 'Leveys'});
            form.find('[name=pcd]').selectize({placeholder: 'Jako'});
            form.find('[name=bore]').selectize({placeholder: 'Keskireikä'});
            form.find('[name=supplier]').selectize({placeholder: 'Toimittaja'});

            var $brand = form.find('[name=brand]'),
                selectedBrand = $brand.val(),
                $model = form.find('[name=model]'),
                selectedModel = $model.val(),
                brand = selectize.api(form, 'brand'),
                model = selectize.api(form, 'model');

            brand.clearOptions();
            brand.addOption(
                _.map(wheelData, function (brand, id) {
                    return {value: id, text: brand.name, '$order': brand.name};
                })
            );
            brand.setValue(selectedBrand);

            var brandChanged = function () {
                var selectedBrand = $brand.val();
                model.clearOptions();
                if (selectedBrand) {
                    model.addOption(
                        _.map(wheelData[selectedBrand].models, function (v) {
                            return {value: v[0], text: v[1], '$order': v[1]};
                        })
                    );
                }
            };
            brand.on('change', brandChanged);

            // Initial
            brandChanged();
            if (selectedModel) {
                model.setValue(selectedModel);
            }
        })();
    }

};



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/forms/non-stock-wheel-search-by-params.js
 **/